var DeliveryMethod;
(function(DeliveryMethod) {
    DeliveryMethod["HomeDelivery"] = 'home-delivery';
    DeliveryMethod["HomeDeliveryExpress"] = 'home-delivery-express';
    DeliveryMethod["NearestPickUp"] = 'nearest-pick-up';
    DeliveryMethod["PickUp"] = 'pick-up';
    DeliveryMethod["DeliveryExpress"] = 'home-delivery-express';
    DeliveryMethod["NearestPickup"] = 'nearest-pick-up';
    DeliveryMethod["PickupPoint"] = 'pick-up-point';
})(DeliveryMethod || (DeliveryMethod = {}));

export { DeliveryMethod };
//# sourceMappingURL=details-order.js.map
